import { Text } from '@/components/ui/text';
import { useAppearance } from '@/lib/design/appearance';
import { getDesignTokens } from '@/lib/design/theme';
import * as React from 'react';
import { StyleSheet } from 'react-native';

export function PublicWebPanelBody({ children }: { children: React.ReactNode }) {
  const resolvedMode = useAppearance((state) => state.resolvedMode);
  const tokens = React.useMemo(() => getDesignTokens(resolvedMode), [resolvedMode]);
  const styles = React.useMemo(() => createStyles(tokens), [tokens]);

  return <Text style={styles.body}>{children}</Text>;
}

function createStyles(tokens: ReturnType<typeof getDesignTokens>) {
  return StyleSheet.create({
    body: {
      color: tokens.colors.textSoft,
      fontFamily: tokens.typography.fonts.bodyMedium,
      fontSize: 15,
      lineHeight: 23,
    },
  });
}
